import { render, staticRenderFns } from "./UploadDocuments.vue?vue&type=template&id=45f90553&scoped=true&lang=pug"
import script from "./UploadDocuments.vue?vue&type=script&lang=ts"
export * from "./UploadDocuments.vue?vue&type=script&lang=ts"
import style0 from "./UploadDocuments.vue?vue&type=style&index=0&id=45f90553&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f90553",
  null
  
)

export default component.exports